import { makeStyles } from "@mui/styles"

const useStyles = makeStyles(theme => {
  return {
    header: {
      color: '#335977',
      fontSize: '30px',
      fontWeight: 'bold',
      margin: '15px 42px 0'
    },
    m0: {
      margin: '0 !important'
    },
    dot: {
      width: '12px',
      height: '12px',
      borderRadius: '12px',
      position: "absolute"
    },
    footerDot: {
      width: '16px',
      height: '16px',
      borderRadius: '12px',
    },
    dotColor: {
      backgroundColor: '#808080',
    },
    inputLabel: {
      color: '#939497',
      fontSize: '16px'
    },
    selectRoot: {
      borderBottom: '1px solid #00000029'
    },
    formControl: {
      margin: '0px 10px 10px 0px',
      height: '35px',
      width: '220px'
    },
    layoutWrapper: {
      display: 'flex',
      '@media (max-width: 425px)': {
        flexDirection: 'column'
      },
    },
    options: {
      color: '#6F6F6F',
      fontSize: '14px',
      marginLeft: '20px'
    },
    cardWrapper: {
      margin: '17px 41px'
    },
    listWrapper: {
      borderRight: '1px solid #00000029',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      '@media (max-width: 425px)': {
        border: 'none'
      },
    },
    optionsWrapper: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
    },
    title: {
      margin: '22px 0 15px',
      color: '#6F6F6F',
      fontSize: '14px',
      fontWeight: 'bold',

      '@media (max-width: 425px)': {
        margin: '10px 0'
      },
    },
    listBox: {
      padding: '0 12px',
      height: 'auto',
      minHeight: '37px',
      width: '150px',
      border: '1px dashed #70707089',
      borderRadius: '4px',
      margin: '6px 0',
      display: 'flex',
      alignItems: 'center',
      color: '#6F6F6F',
      fontSize: '14px',
      backgroundColor: '#F5F5F5',
      cursor: 'pointer',
      overflowWrap: 'anywhere',
      '@media (max-width: 425px)': {
        width: '100%'
      },
    },
    activeBox: {
      border: '1px solid #F3731F',
      fontWeight: 'bolder',
      color: '#000000'
    },
    pagination: {
      padding: '0px 22px',
      margin: '40px auto 25px',

      '@media (max-width: 425px)': {
        margin: '10px auto',
      },
    },
    listContainer: {
      padding: '22px 0',
      width: '270px',

      '@media (max-width: 425px)': {
        padding: '22px 0 12px',
        width: '100%'
      },
    },
    list: {
      padding: '0 40px',
    },
    detailContainer: {
      margin: '25px 20px 0',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',

      '@media (max-width: 425px)': {
        margin: '10px 20px auto',
        width: 'auto'
      },
    },
    footer: {
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      minHeight: '80px',
      borderTop: '1px solid #00000029',

      '@media (max-width: 425px)': {
        height: 'auto',
        overflow: 'auto',
        flexDirection: 'column'
      },
    },
    validationText: {
      color: '#F37320',
      fontSize: '14px'
    },
    footerLink: {
      color: '#7C7B7B',
      fontSize: '16px',
      marginRight: '5px'
    },
    link: {
      color: '#F37320',
      fontSize: '16px',
      textDecoration: 'underline'
    },
    buttonWrapper: {
      display: 'flex',
      alignItems: 'center',
      width: '50%'
    },
    button: {
      width: '150px',
      height: '36px',
      textTransform: 'capitalize',
      fontSize: '14px'
    },
    largeButton: {
      width: '200px',
      marginLeft: '0px',
      minHeight: '36px'
    },
    approveButton: {
      marginRight: '13px'
    },
    rejectButton: {
      border: '1px solid #C7C8CA'
    },
    pdfToggle: {
      width: 'fit-content',
      height: '36px',
      backgroundColor: '#F5F5F5',
      border: '1px solid #D0D0D0',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      padding: '0 15px 0 5px',
      marginRight: '14px',
      marginBottom: '10px',
      cursor: 'pointer',
      margin: '5px',

      '& p': {
        color: '#545456',
        fontSize: '12px',
        marginLeft: '12px'
      }
    },
    selectedPdf: {
      border: '1px solid #F37320',
      '& p': {
        color: '#F37320',
        fontSize: '12px',
        marginLeft: '12px',
      }
    },
    detailWrapper: {
      marginBottom: '26px'
    },
    wrapper: {
      display: 'flex',
    },
    empty: {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#6F6F6F',
      fontWeight: 'bold',
      fontSize: '14px',

      '@media (max-width: 425px)': {
        marginBottom: '20px'
      },
    },
    pdfViewerWrapper: {
      width: '50%',
      display: 'flex',
      flexDirection: 'column',

      '@media (max-width: 1024px)': {
        width: '100%'
      },
    },
    downloadButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: '22px',
      cursor: 'pointer',

      '& p': {
        marginLeft: '10px',
        color: '#707070',
        fontSize: '12px',
      },

      '@media (max-width: 1024px)': {
        marginBottom: '10px'
      },
    },
    buttonGroup: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      marginBottom: '26px',
    },
    siteButton: {
      border: '1px solid #70707033',
      color: '#545456',
      fontSize: '12px',
      maxWidth: '200px',
      minHeight: '36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#F8F8F8',
      borderRadius: '4px',
      cursor: 'pointer',
      marginTop: '5px',
      textAlign: 'center',
      '@media (min-width: 1025px)': {
        padding: '0 18px'
      },
    },
    spaceBtw: {
      justifyContent: 'space-between',

      '@media (max-width: 1024px)': {
        flexDirection: 'column'
      },
    },
    formWrapper: {
      width: '45%',
      maxHeight: '550px',
      overflow: 'scroll',

      '&::-webkit-scrollbar': {
        width: '3px'
      },

      '&::-webkit-scrollbar-thumb': {
        borderRadius: '3px',
        backgroundColor: '#c3c3c3'
      },
    },
    formFields: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 0',
      borderBottom: '1px solid #70707033',
      flexWrap: 'wrap'
    },
    formButton: {
      width: '120px',
      minHeight: '20px',
      margin: '0 13px 0 0'
    },
    formReject: {
      color: '#545456 !important'
    },
    label: {
      color: '#939497',
      fontSize: '12px'
    },
    value: {
      color: '#545455',
      fontSize: '14px',
      overflowWrap: 'break-word'
    },
    status: {
      width: '120px',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '13px',
      fontSize: '10px',
      color: '#545456',
      fontWeight: 'bold',

      '& span': {
        widht: '16px',
        height: '16px',
        marginRight: '7px'
      }
    },
    textBox: {
      width: 382
    },
    modalText: {
      color: '#565657',
      fontSize: '20px',
      fontWeight: 'bold',
      marginBottom: '16px',
      textAlign: 'center'
    },
    modalWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    modalButton: {
      width: '120px',
      minHeight: '36px',
      margin: 0,
    },
    modalButtonGrp: {
      width: '70%',
      justifyContent: 'space-between',
      marginTop: '36px'
    },
    statusTextWrapper: {
      display: 'flex',
      alignItems: 'center',
      margin: '10px 0',
      width: '100%',
    },
    statusWrapper: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    statusText: {
      color: '#F37320',
      fontSize: '14px',
      marginLeft: '12px'
    },
    showReason: {
      color: '#2079F3 !important',
      fontSize: '14px',
      marginLeft: '12px',
      textDecoration: 'underline',
      cursor: 'pointer'
    },
    message: {
      color: '#000000',
      fontSize: '14px'
    },
    closeButton: {
      border: '1px solid #C7C8CA',
      color: '#4A4A4A !important',
      fontSize: '14px',
      textTransform: 'capitalize',
      width: '110px',
      margin: '30px auto 0',
      minHeight: '36px'
    },
    menu: {
      borderBottom: '1px solid #00000029',

      '&:last-child': {
        border: 'none'
      }
    },
    rowWrapper: {
      width: '50%'
    },
    reasonModal: {
      '& #alert-dialog-title': {
        color: '#565657',
        fontSize: '20px',
        fontWeight: 'bold',
        textAlign: 'center'
      },
      '& #alert-dialog-description': {
        padding: 0
      }
    },
    reasonWrapper: {
      border: '1px solid #F37320',
      padding: '10px',
      maxHeight: '100px',
      overflowY: 'auto',
      borderRadius: '10px',
      wordBreak: 'break-word'
    },
    errorIcon: {
      color: '#F37320',
      width: '82px',
      height: '82px'
    },
    errorText: {
      color: '#565657',
      fontSize: '20px',
      fontWeight: 'bold',
      textAlign: 'center'
    },
    inputRoot: {
      width: '200px'
    },
    downloadWrapper: {
      height: '500px',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center'
    },
    downloadContent: {
      color: '#707070',
      fontSize: '12px',
      marginTop: '15px'
    },
    formUploaded: {
      fontSize: '14px',
      color: '#000000',
      marginLeft: '14px'
    },
    referenceIdWrapper: {
      margin: '20px 0 20px 30px'
    },
    referenceLabel: {
      color: '#939497',
      fontSize: '16px'
    },
    referenceId: {
      color: '#000000',
      fontSize: '14px'
    },
    formUploadedWrapper: {
      display: 'flex',
      alignItems: 'center',
      marginTop: '10px'
    },
    utilityLogo: {
      width: '20%'
    }
  }
})

export { useStyles }